export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-dashboard',
      badge: {
        variant: 'primary',
        text: 'NEW'
      }
    },
    {
      title: true,
      name: 'Berita',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Daftar Berita',
      url: '/news',
      icon: '	fa fa-edit'
    },
    {
      title: true,
      name: 'Pendanaan',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Daftar Pendanaan',
      url: '/funding',
      icon: 'fa fa-star'
    },
    {
      name: 'Konfirm Pembayaran',
      url: '/payment',
      icon: 'fa fa-money'
    },
    {
      title: true,
      name: 'Penyaluran',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Penyaluran Bantuan',
      url: '/penyaluran',
      icon: 'fa fa-handshake-o'
    },
    {
      divider: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js